import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const NoResultsContent = styled.div`
  font-size: 1.25rem;
  @media (min-width: ${({ theme }) => theme.media.sm}) {
    width: 26.25rem;
  }
`;
